<template>
  <div class="relative flex mr-4 desktop:mr-6">
    <lm-icon-button
      icon="people"
      class="mr-2 desktop:mr-4"
      svg
      bg-black
      tooltip="Manage users"
      @click="openUserList"
    />
    <lm-notifications class="mr-2 desktop:mr-4" />
    <lm-icon-button
      v-if="hasAdminRights"
      icon="settings"
      svg
      bg-black
      tooltip="Landscape Settings"
      @click="goToSettings"
    />
    <lm-dropdown
      v-else
      class="LandscapeOptions-menu"
      :items="options"
      icon-color="grey"
      auto-close
      @select="onSelect"
    />
  </div>
</template>

<script>
import LmNotifications from '@/components/common/header/LmNotifications'
import LmDropdown from '@/components/ui/LmDropdown'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import LmIconButton from '@/components/ui/LmIconButton'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'

export default {
  name: 'LandscapeOptions',
  components: {
    LmDropdown,
    LmNotifications,
    LmIconButton
  },
  computed: {
    ...mapGetters([
      'currentLandscape',
      'startPage',
      'hasAdminRights',
      'isOwner',
      'findLandscapeBySlug'
    ]),
    default() {
      return (
        this.currentLandscape && this.currentLandscape.slug === this.startPage
      )
    },
    currentLandscapeData() {
      if (this.currentLandscape) return this.currentLandscape
      const landscape = this.findLandscapeBySlug(
        this.$route.params.landscapeSlug
      )
      return Object.assign(landscape, {stats: {}})
    },
    options() {
      const actions = []
      if (!this.default && this.currentLandscape) {
        actions.push({action: 'default', label: 'Set As Start Page'})
      }
      if (!this.isOwner && !this.isAdmin) {
        actions.push({action: 'leave', label: 'Leave Landscape'})
      }
      return actions
    }
  },
  methods: {
    onSelect(item) {
      switch (item.action) {
        case 'default':
          this.setStartPage()
          break
        case 'leave':
          this.leaveLandscape()
          break
      }
    },
    goToSettings() {
      this.$router.push({name: 'settings'})
    },
    openUserList() {
      this.$router.push({query: {modal: Modal.USER_LIST}})
    },
    setStartPage() {
      this.$store
        .dispatch('setStartPage', this.currentLandscape.slug)
        .then(() =>
          EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.START_PAGE)
        )
    },
    leaveLandscape() {
      let params = {
        action: 'Leave',
        entity: 'landscape',
        prompt: `
              Are you sure you want to leave the landscape
              <span class="u-highlight">${this.currentLandscapeData.name}</span>?
            `
      }
      EventHub.emit(Events.OPEN_CONFIRM, params, this.doLeaveLandscape)
    },
    doLeaveLandscape() {
      this.$store
        .dispatch('leaveLandscape', this.currentLandscapeData._id)
        .then(() => this.$router.push({name: 'home'}))
    }
  }
}
</script>
